export const OverlayTemplate = ({ customVerbiage }) => {
  return (
    <div className="ag-overlay-no-rows-wrapper">
        <div className="ag-overlay-no-rows-panel">
          <span className="ag-overlay-no-rows-center">{customVerbiage}</span>
        </div>
    </div>
  );
}
